var map = {
	"./categories.svg": 1620,
	"./icons/airplane.svg": 789,
	"./icons/angle-down.svg": 790,
	"./icons/angle-left.svg": 791,
	"./icons/angle-right.svg": 792,
	"./icons/arrow-left.svg": 793,
	"./icons/back.svg": 794,
	"./icons/backward.svg": 795,
	"./icons/bell.svg": 796,
	"./icons/bookmark.svg": 797,
	"./icons/burger.svg": 798,
	"./icons/calendar.svg": 799,
	"./icons/circle-minus.svg": 800,
	"./icons/circle-plus.svg": 801,
	"./icons/clock.svg": 802,
	"./icons/close.svg": 803,
	"./icons/comments.svg": 804,
	"./icons/crown.svg": 805,
	"./icons/d-plius.svg": 806,
	"./icons/door.svg": 807,
	"./icons/envelope.svg": 808,
	"./icons/forecast-cloud.svg": 809,
	"./icons/forward.svg": 810,
	"./icons/gallery-border.svg": 811,
	"./icons/gallery.svg": 812,
	"./icons/group.svg": 813,
	"./icons/home.svg": 814,
	"./icons/info-circle.svg": 815,
	"./icons/issue-toc.svg": 816,
	"./icons/link.svg": 817,
	"./icons/listen.svg": 818,
	"./icons/live.svg": 819,
	"./icons/microphone.svg": 820,
	"./icons/mobile.svg": 821,
	"./icons/most-bought.svg": 822,
	"./icons/news-paper.svg": 823,
	"./icons/next.svg": 824,
	"./icons/pause.svg": 825,
	"./icons/pc.svg": 826,
	"./icons/play.svg": 827,
	"./icons/plus.svg": 828,
	"./icons/prev.svg": 829,
	"./icons/print.svg": 830,
	"./icons/question-bubble.svg": 831,
	"./icons/saugu.svg": 832,
	"./icons/search.svg": 833,
	"./icons/share.svg": 834,
	"./icons/social-envelope.svg": 835,
	"./icons/social-facebook-circle.svg": 836,
	"./icons/social-facebook.svg": 837,
	"./icons/social-instagram.svg": 838,
	"./icons/social-linkedin.svg": 839,
	"./icons/social-messenger.svg": 840,
	"./icons/social-twitter.svg": 841,
	"./icons/social-vk.svg": 842,
	"./icons/speed.svg": 843,
	"./icons/success.svg": 844,
	"./icons/text-size.svg": 845,
	"./icons/tick.svg": 846,
	"./icons/total-package.svg": 847,
	"./icons/trash.svg": 848,
	"./icons/trending.svg": 849,
	"./icons/user-picture.svg": 850,
	"./icons/user.svg": 851,
	"./icons/warning.svg": 852,
	"./meal-time.svg": 1621,
	"./portions.svg": 1622,
	"./preparation-time.svg": 1623,
	"./quote.svg": 855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1070;